import { Cookies } from 'react-cookie';

import { InteractiveMapPlan } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const putInteractiveMapPlan = async (object: InteractiveMapPlan) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();
  formData.append('uploaded_file', object.uploaded_file);
  formData.append('title', object.title);

  const { data } = await axiosInterceptor.patch(`v1/objects/${object.site_slug}/plans/${object.slug}/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data as any;
};
